import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './skeletonLoader.module.scss';
import { cx } from 'class-variance-authority';

export function BaseSkeleton() {
  return (
    <Skeleton
      className={styles.skeleton}
      baseColor="#f0f3f9"
      highlightColor="#f9fafd"
    />
  );
}

function SkeletonContent() {
  return (
    <div className={styles.skeletonContent}>
      <div className={styles.skeletonSubheader}>
        <BaseSkeleton />
      </div>
      <div className={styles.skeletonText}>
        <BaseSkeleton />
      </div>
      <div className={styles.skeletonText}>
        <BaseSkeleton />
      </div>
      <div className={cx(styles.skeletonText, styles.skeletonTextShort)}>
        <BaseSkeleton />
      </div>
    </div>
  );
}

export default function SkeletonLoader({
  className,
  count = 1
}: Readonly<{
  className?: string;
  count?: number;
}>) {
  return (
    <div className={cx(styles.skeletonLoader, className)}>
      <div className={styles.skeletonHeader}>
        <BaseSkeleton />
      </div>
      {[...Array(count).keys()].map((count) => (
        <SkeletonContent key={`skeleton-${count}`} />
      ))}
    </div>
  );
}
